import { render } from "./to-the-top-block.vue?vue&type=template&id=503e737e"
import script from "./to-the-top-block.vue?vue&type=script&lang=js"
export * from "./to-the-top-block.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__